"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiException = exports.UpdateFileTypeBody = exports.Unit = exports.Supplier = exports.StockFile = exports.PurchaseOrderLine = exports.PurchaseOrder = exports.MatchedOnType = exports.ItemSupplierVariant = exports.Item = exports.InvoiceVersion = exports.InvoiceLine = exports.Invoice = exports.FileType = exports.ErrorDto = exports.Brand = exports.StockClient = exports.ClientBase = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
const dayjs = require("dayjs");
class ClientBase {
    constructor(config) {
        this.authToken = config.authToken;
        this.companyId = config.companyId;
    }
    transformOptions(options) {
        const authToken = typeof this.authToken === 'function' ? this.authToken() : this.authToken;
        const companyId = typeof this.companyId === 'function' ? this.companyId() : this.companyId;
        options.headers = Object.assign(Object.assign({}, options.headers), { Authorization: `Bearer ${authToken}`, 'x-loaded-company-id': companyId });
        return Promise.resolve(options);
    }
}
exports.ClientBase = ClientBase;
class StockClient extends ClientBase {
    constructor(configuration, baseUrl, http) {
        super(configuration);
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @return OK
     */
    getBrands() {
        let url_ = this.baseUrl + "/1.0/stock/internal/brands";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetBrands(_response);
        });
    }
    processGetBrands(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(Brand.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param file (optional)
     * @return Created
     */
    uploadFile(file) {
        let url_ = this.baseUrl + "/1.0/stock/files";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUploadFile(_response);
        });
    }
    processUploadFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = StockFile.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    updateFile(fileId, body) {
        let url_ = this.baseUrl + "/1.0/stock/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateFile(_response);
        });
    }
    processUpdateFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    downloadFile(fileId) {
        let url_ = this.baseUrl + "/1.0/stock/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDownloadFile(_response);
        });
    }
    processDownloadFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    getUnclassifiedFiles() {
        let url_ = this.baseUrl + "/1.0/stock/files/unclassified";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetUnclassifiedFiles(_response);
        });
    }
    processGetUnclassifiedFiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(StockFile.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Created
     */
    createInvoice(body) {
        let url_ = this.baseUrl + "/1.0/stock/invoices";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateInvoice(_response);
        });
    }
    processCreateInvoice(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Invoice.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    getInvoice(identifier) {
        let url_ = this.baseUrl + "/1.0/stock/invoices/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetInvoice(_response);
        });
    }
    processGetInvoice(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Invoice.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param start (optional)
     * @param end (optional)
     * @param invoiceNumber (optional)
     * @param supplierName (optional)
     * @return OK
     */
    getInvoices(start, end, invoiceNumber, supplierName) {
        let url_ = this.baseUrl + "/1.0/stock/internal/invoices?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (invoiceNumber === null)
            throw new Error("The parameter 'invoiceNumber' cannot be null.");
        else if (invoiceNumber !== undefined)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (supplierName === null)
            throw new Error("The parameter 'supplierName' cannot be null.");
        else if (supplierName !== undefined)
            url_ += "supplierName=" + encodeURIComponent("" + supplierName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetInvoices(_response);
        });
    }
    processGetInvoices(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(Invoice.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    getInitialInvoice(identifier) {
        let url_ = this.baseUrl + "/1.0/stock/internal/invoices/{identifier}/initial";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetInitialInvoice(_response);
        });
    }
    processGetInitialInvoice(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Invoice.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    getInvoiceHistory(identifier) {
        let url_ = this.baseUrl + "/1.0/stock/internal/invoices/{identifier}/history";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetInvoiceHistory(_response);
        });
    }
    processGetInvoiceHistory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Invoice.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    updateInvoice(identifier, body) {
        let url_ = this.baseUrl + "/1.0/stock/internal/invoices/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateInvoice(_response);
        });
    }
    processUpdateInvoice(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Invoice.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return No Content
     */
    deleteInvoice(identifier) {
        let url_ = this.baseUrl + "/1.0/stock/internal/invoices/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeleteInvoice(_response);
        });
    }
    processDeleteInvoice(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    getItems() {
        let url_ = this.baseUrl + "/1.0/stock/internal/items";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetItems(_response);
        });
    }
    processGetItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(Item.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param purchaseOrderNumber (optional)
     * @return OK
     */
    getPurchaseOrders(purchaseOrderNumber) {
        let url_ = this.baseUrl + "/1.0/stock/internal/purchase-orders?";
        if (purchaseOrderNumber === null)
            throw new Error("The parameter 'purchaseOrderNumber' cannot be null.");
        else if (purchaseOrderNumber !== undefined)
            url_ += "purchaseOrderNumber=" + encodeURIComponent("" + purchaseOrderNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPurchaseOrders(_response);
        });
    }
    processGetPurchaseOrders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PurchaseOrder.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    getPurchaseOrder(identifier) {
        let url_ = this.baseUrl + "/1.0/stock/internal/purchase-orders/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPurchaseOrder(_response);
        });
    }
    processGetPurchaseOrder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrder.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    getSuppliers() {
        let url_ = this.baseUrl + "/1.0/stock/internal/suppliers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetSuppliers(_response);
        });
    }
    processGetSuppliers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(Supplier.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Created
     */
    createSupplier(body) {
        let url_ = this.baseUrl + "/1.0/stock/internal/suppliers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCreateSupplier(_response);
        });
    }
    processCreateSupplier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Supplier.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    getSupplier(identifier) {
        let url_ = this.baseUrl + "/1.0/stock/internal/suppliers/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetSupplier(_response);
        });
    }
    processGetSupplier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Supplier.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorDto.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    getUnits() {
        let url_ = this.baseUrl + "/1.0/stock/internal/units";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetUnits(_response);
        });
    }
    processGetUnits(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(Unit.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
exports.StockClient = StockClient;
class Brand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.masterId = _data["masterId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Brand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["masterId"] = this.masterId;
        return data;
    }
}
exports.Brand = Brand;
class ErrorDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.errorId = _data["errorId"];
            this.messages = _data["messages"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["errorId"] = this.errorId;
        data["messages"] = this.messages;
        return data;
    }
}
exports.ErrorDto = ErrorDto;
var FileType;
(function (FileType) {
    FileType[FileType["Invoice"] = "Invoice"] = "Invoice";
    FileType[FileType["CreditNote"] = "CreditNote"] = "CreditNote";
    FileType[FileType["Unknown"] = "Unknown"] = "Unknown";
})(FileType || (exports.FileType = FileType = {}));
class Invoice {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.version = _data["version"];
            this.issuedAt = _data["issuedAt"];
            this.dueAt = _data["dueAt"];
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            this.total = _data["total"];
            this.taxNumber = _data["taxNumber"];
            this.supplierName = _data["supplierName"];
            this.supplierAddress = _data["supplierAddress"];
            this.linkedSupplierId = _data["linkedSupplierId"];
            this.billingName = _data["billingName"];
            this.billingAddress = _data["billingAddress"];
            this.shippingName = _data["shippingName"];
            this.shippingAddress = _data["shippingAddress"];
            this.paymentTerms = _data["paymentTerms"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.linkedPurchaseOrderId = _data["linkedPurchaseOrderId"];
            this.receivedAt = _data["receivedAt"] ? dayjs(_data["receivedAt"].toString()) : undefined;
            this.isReceived = _data["isReceived"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [];
                for (let item of _data["lines"])
                    this.lines.push(InvoiceLine.fromJS(item));
            }
            this.fileId = _data["fileId"];
            this.unitCostIncludesTax = _data["unitCostIncludesTax"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["version"] = this.version;
        data["issuedAt"] = this.issuedAt;
        data["dueAt"] = this.dueAt;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["total"] = this.total;
        data["taxNumber"] = this.taxNumber;
        data["supplierName"] = this.supplierName;
        data["supplierAddress"] = this.supplierAddress;
        data["linkedSupplierId"] = this.linkedSupplierId;
        data["billingName"] = this.billingName;
        data["billingAddress"] = this.billingAddress;
        data["shippingName"] = this.shippingName;
        data["shippingAddress"] = this.shippingAddress;
        data["paymentTerms"] = this.paymentTerms;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["linkedPurchaseOrderId"] = this.linkedPurchaseOrderId;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toISOString() : undefined;
        data["isReceived"] = this.isReceived;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["fileId"] = this.fileId;
        data["unitCostIncludesTax"] = this.unitCostIncludesTax;
        return data;
    }
}
exports.Invoice = Invoice;
class InvoiceLine {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.brand = _data["brand"];
            this.unit = _data["unit"];
            this.quantityOrdered = _data["quantityOrdered"];
            this.quantityReceived = _data["quantityReceived"];
            this.unitCost = _data["unitCost"];
            this.totalCost = _data["totalCost"];
            this.taxAmount = _data["taxAmount"];
            this.linkedUnitId = _data["linkedUnitId"];
            this.linkedItemId = _data["linkedItemId"];
            this.linkedBrandId = _data["linkedBrandId"];
            this.itemMatchedOn = _data["itemMatchedOn"];
            this.deletedAt = _data["deletedAt"] ? dayjs(_data["deletedAt"].toString()) : undefined;
            this.saleTaxRate = _data["saleTaxRate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLine();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["brand"] = this.brand;
        data["unit"] = this.unit;
        data["quantityOrdered"] = this.quantityOrdered;
        data["quantityReceived"] = this.quantityReceived;
        data["unitCost"] = this.unitCost;
        data["totalCost"] = this.totalCost;
        data["taxAmount"] = this.taxAmount;
        data["linkedUnitId"] = this.linkedUnitId;
        data["linkedItemId"] = this.linkedItemId;
        data["linkedBrandId"] = this.linkedBrandId;
        data["itemMatchedOn"] = this.itemMatchedOn;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined;
        data["saleTaxRate"] = this.saleTaxRate;
        return data;
    }
}
exports.InvoiceLine = InvoiceLine;
var InvoiceVersion;
(function (InvoiceVersion) {
    InvoiceVersion[InvoiceVersion["Initial"] = "Initial"] = "Initial";
    InvoiceVersion[InvoiceVersion["Current"] = "Current"] = "Current";
    InvoiceVersion[InvoiceVersion["Failed"] = "Failed"] = "Failed";
})(InvoiceVersion || (exports.InvoiceVersion = InvoiceVersion = {}));
class Item {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.name = _data["name"];
            this.unitType = _data["unitType"];
            this.countingUnitId = _data["countingUnitId"];
            this.orderingUnitId = _data["orderingUnitId"];
            this.globalPrice = _data["globalPrice"];
            this.globalSalesTaxSortOrder = _data["globalSalesTaxSortOrder"];
            this.datestampRemoved = _data["datestampRemoved"] ? dayjs(_data["datestampRemoved"].toString()) : undefined;
            this.defaultSupplierId = _data["defaultSupplierId"];
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [];
                for (let item of _data["suppliers"])
                    this.suppliers.push(ItemSupplierVariant.fromJS(item));
            }
            this.masterId = _data["masterId"];
            this.defaultBrandId = _data["defaultBrandId"];
            this.currentPrice = _data["currentPrice"];
            this.currentPricePurchaseOrderId = _data["currentPricePurchaseOrderId"];
            this.systemItem = _data["systemItem"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["name"] = this.name;
        data["unitType"] = this.unitType;
        data["countingUnitId"] = this.countingUnitId;
        data["orderingUnitId"] = this.orderingUnitId;
        data["globalPrice"] = this.globalPrice;
        data["globalSalesTaxSortOrder"] = this.globalSalesTaxSortOrder;
        data["datestampRemoved"] = this.datestampRemoved ? this.datestampRemoved.toISOString() : undefined;
        data["defaultSupplierId"] = this.defaultSupplierId;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        data["masterId"] = this.masterId;
        data["defaultBrandId"] = this.defaultBrandId;
        data["currentPrice"] = this.currentPrice;
        data["currentPricePurchaseOrderId"] = this.currentPricePurchaseOrderId;
        data["systemItem"] = this.systemItem;
        return data;
    }
}
exports.Item = Item;
class ItemSupplierVariant {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.stockItemId = _data["stockItemId"];
            this.supplierId = _data["supplierId"];
            this.brandId = _data["brandId"];
            this.unitId = _data["unitId"];
            this.unitCost = _data["unitCost"];
            this.stockCode = _data["stockCode"];
            this.defaultForSupplier = _data["defaultForSupplier"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemSupplierVariant();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockItemId"] = this.stockItemId;
        data["supplierId"] = this.supplierId;
        data["brandId"] = this.brandId;
        data["unitId"] = this.unitId;
        data["unitCost"] = this.unitCost;
        data["stockCode"] = this.stockCode;
        data["defaultForSupplier"] = this.defaultForSupplier;
        data["description"] = this.description;
        return data;
    }
}
exports.ItemSupplierVariant = ItemSupplierVariant;
var MatchedOnType;
(function (MatchedOnType) {
    MatchedOnType[MatchedOnType["Code"] = "Code"] = "Code";
    MatchedOnType[MatchedOnType["Description"] = "Description"] = "Description";
})(MatchedOnType || (exports.MatchedOnType = MatchedOnType = {}));
class PurchaseOrder {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : undefined;
            this.receivedAt = _data["receivedAt"] ? dayjs(_data["receivedAt"].toString()) : undefined;
            this.invoicedAt = _data["invoicedAt"] ? dayjs(_data["invoicedAt"].toString()) : undefined;
            this.isReceived = _data["isReceived"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [];
                for (let item of _data["lines"])
                    this.lines.push(PurchaseOrderLine.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrder();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toISOString() : undefined;
        data["invoicedAt"] = this.invoicedAt ? this.invoicedAt.toISOString() : undefined;
        data["isReceived"] = this.isReceived;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}
exports.PurchaseOrder = PurchaseOrder;
class PurchaseOrderLine {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.lineOrder = _data["lineOrder"];
            this.itemId = _data["itemId"];
            this.itemCode = _data["itemCode"];
            this.brandId = _data["brandId"];
            this.brandName = _data["brandName"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
            this.unitCost = _data["unitCost"];
            this.quantity = _data["quantity"];
            this.taxPercent = _data["taxPercent"];
            this.quantityOrdered = _data["quantityOrdered"];
            this.unitCostOrdered = _data["unitCostOrdered"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderLine();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["lineOrder"] = this.lineOrder;
        data["itemId"] = this.itemId;
        data["itemCode"] = this.itemCode;
        data["brandId"] = this.brandId;
        data["brandName"] = this.brandName;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        data["unitCost"] = this.unitCost;
        data["quantity"] = this.quantity;
        data["taxPercent"] = this.taxPercent;
        data["quantityOrdered"] = this.quantityOrdered;
        data["unitCostOrdered"] = this.unitCostOrdered;
        return data;
    }
}
exports.PurchaseOrderLine = PurchaseOrderLine;
class StockFile {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.fileType = _data["fileType"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StockFile();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["fileType"] = this.fileType;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.StockFile = StockFile;
class Supplier {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.postcode = _data["postcode"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.contactName = _data["contactName"];
            this.unitCostIncludesTax = _data["unitCostIncludesTax"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["postcode"] = this.postcode;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["contactName"] = this.contactName;
        data["unitCostIncludesTax"] = this.unitCostIncludesTax;
        return data;
    }
}
exports.Supplier = Supplier;
class Unit {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.unitType = _data["unitType"];
            this.ratio = _data["ratio"];
            this.name = _data["name"];
            this.datestampDeleted = _data["datestampDeleted"] ? dayjs(_data["datestampDeleted"].toString()) : undefined;
            this.masterId = _data["masterId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitType"] = this.unitType;
        data["ratio"] = this.ratio;
        data["name"] = this.name;
        data["datestampDeleted"] = this.datestampDeleted ? this.datestampDeleted.toISOString() : undefined;
        data["masterId"] = this.masterId;
        return data;
    }
}
exports.Unit = Unit;
class UpdateFileTypeBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fileType = _data["fileType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFileTypeBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileType"] = this.fileType;
        return data;
    }
}
exports.UpdateFileTypeBody = UpdateFileTypeBody;
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
